export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agroexportadores"])},
          "go-back-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de agroexportadores"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agro Exporters"])},
          "go-back-link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to the list of agro exporters"])},
          "show_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Containers"])}
        }
      }
    }
  })
}